import Headings from "../../../components/Texts/Headings";
import PastLoanCard from "./PastLoanCard"
const PastLoanComponent = ({ pastLoans }) => {
  return (
    <div className="flex flex-col  gap-[24px]">
      <Headings
        variant="LoanHeading"
        text="COMPLETED"
      />
      {pastLoans?.map((item, index) => item?.type == "completed" ?
        <PastLoanCard {...item} /> : ""
      )}
      <Headings
        variant="LoanHeading"
        text="REJECTED"
        className="mt-[12px]"
      />
      {pastLoans?.map((item, index) => item?.type == "rejected" ?
        <PastLoanCard {...item} /> : ""
      )}
    </div>
  )
}
export default PastLoanComponent;